import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from "../../common/providers/api-base-service";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { CurrentUser } from "../../common/providers/current-user";
import { Paginator } from "../../common/models/paginator";

@Injectable({
    providedIn: 'root'
})
export class FeedbackAthleteAnswerProvider {
    constructor(
        private api: ApiBaseService,
        private currentUser: CurrentUser,
    ) {}

    public findById(feedbackAthleteAnswerId: number): Observable<any> {
        return this.api.call('get',`feedback/answers/${feedbackAthleteAnswerId}`, {}, this.currentUser.getAccessToken());
    }

    /**
     * Find all FeedbackAthleteAnswer by Organization and Athlete
     */
    public findAllByOrganizationAndAthletePaginated(organization: Organization, athlete: Athlete, page = 0, query = ''): Observable<Paginator> {
        return this.api.call('get',`organizations/${organization.id}/feedback/athlete/${athlete.userId}?page=${page}&q=${query}`, {}, this.currentUser.getAccessToken());
    }

    public findLatestFeedbackMood(organization: Organization, athlete: Athlete): Observable<any> {
        return this.api.call('get',`organizations/${organization.code}/feedback/athlete/${athlete.userId}/mood`, {}, this.currentUser.getAccessToken());
    }

    public findLatestFeedback(organization: Organization, athlete: Athlete): Observable<any[]> {
        return this.api.call('get',`organizations/${organization.code}/feedback/athlete/${athlete.userId}/latest`, {}, this.currentUser.getAccessToken());
    }

    public deleteById(organization: Organization, feedbackAthleteAnswerId: number): Observable<void> {
        // return this.api.call('delete',`feedback/answers/${feedbackAthleteAnswerId}`);
        return this.api.call('delete',`organizations/${organization.code}/feedback/answers/${feedbackAthleteAnswerId}`, {}, this.currentUser.getAccessToken());
    }
}

export class LatestFeedbackData {
    public answerLabel: number;
    public answerUserData: string;
    public answerValue: string;
    public answeredAt: string;
    public questionTitle: string;
    public questionType: string;

    constructor(answerLabel: number, answerUserData: string, answerValue: string, answeredAt: string, questionTitle: string, questionType: string) {
        this.answerLabel = answerLabel;
        this.answerUserData = answerUserData;
        this.answerValue = answerValue;
        this.answeredAt = answeredAt;
        this.questionTitle = questionTitle;
        this.questionType = questionType;
    }
}
